/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoleResponseDto
 */
export interface RoleResponseDto {
    /**
     * 
     * @type {string}
     * @memberof RoleResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof RoleResponseDto
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof RoleResponseDto
     */
    isSystemRole: boolean;
    /**
     * 
     * @type {string}
     * @memberof RoleResponseDto
     */
    organizationId: string | null;
    /**
     * 
     * @type {number}
     * @memberof RoleResponseDto
     */
    usersCount: number;
    /**
     * 
     * @type {Date}
     * @memberof RoleResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof RoleResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the RoleResponseDto interface.
 */
export function instanceOfRoleResponseDto(value: object): value is RoleResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isSystemRole' in value) || value['isSystemRole'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('usersCount' in value) || value['usersCount'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function RoleResponseDtoFromJSON(json: any): RoleResponseDto {
    return RoleResponseDtoFromJSONTyped(json, false);
}

export function RoleResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'isSystemRole': json['isSystemRole'],
        'organizationId': json['organizationId'],
        'usersCount': json['usersCount'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function RoleResponseDtoToJSON(json: any): RoleResponseDto {
    return RoleResponseDtoToJSONTyped(json, false);
}

export function RoleResponseDtoToJSONTyped(value?: RoleResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'isSystemRole': value['isSystemRole'],
        'organizationId': value['organizationId'],
        'usersCount': value['usersCount'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

